<template>
  <div v-if="summary" class="small text-body-tertiary text-truncate">
    {{ summary }}
  </div>
</template>

<script setup lang="ts">
import type { TgeStatementOptions } from "@/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  options?: TgeStatementOptions | null;
}>();

const { t } = useI18n();

const summary = computed(() => {
  const parts: string[] = [];
  if (props.options?.legal_form) {
    parts.push(
      t(`go_cancel.form.tge_legal_form.options.${props.options.legal_form}`)
    );
  }
  if (props.options?.vat_number) {
    parts.push(
      `${t("go_cancel.form.tge_vat_number.short_label")} ${props.options.vat_number}`
    );
  }
  return parts.join(" · ");
});
</script>
